import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosHumanResourcesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosHumanResourcesController.php
* @route '/api/partner/enaos/human-resources'
*/
const GetEnaosHumanResourcesController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEnaosHumanResourcesController.url(options),
    method: 'get',
})

GetEnaosHumanResourcesController.definition = {
    methods: ["get","head"],
    url: '/api/partner/enaos/human-resources',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosHumanResourcesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosHumanResourcesController.php
* @route '/api/partner/enaos/human-resources'
*/
GetEnaosHumanResourcesController.url = (options?: RouteQueryOptions) => {
    return GetEnaosHumanResourcesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosHumanResourcesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosHumanResourcesController.php
* @route '/api/partner/enaos/human-resources'
*/
GetEnaosHumanResourcesController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEnaosHumanResourcesController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosHumanResourcesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosHumanResourcesController.php
* @route '/api/partner/enaos/human-resources'
*/
GetEnaosHumanResourcesController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetEnaosHumanResourcesController.url(options),
    method: 'head',
})

export default GetEnaosHumanResourcesController